import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function ForWhom() {
  return <section className="py-24 bg-cream" data-id="element-116">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-117">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-118">
          <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-119">
            ¿Es esto para ti?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-120">
          {/* Para ti si */}
          <motion.div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border-t-4 border-sage" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-121">
            <h3 className="text-2xl font-serif mb-6 text-forest" data-id="element-122">
              ESTO ES PARA TI SI...
            </h3>
            <ul className="space-y-4" data-id="element-123">
              {['Tienes entre 45 y 65 años y sientes que tu metabolismo cambió.', "Sientes tu cuerpo 'pesado', rígido e inflamado constantemente.", 'Estás lista para soltar alimentos y hábitos que ya no te sirven.', 'Buscas una solución natural, basada en escuchar a tu cuerpo.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-124">
                  <CheckIcon className="w-6 h-6 text-sage shrink-0 mt-0.5" data-id="element-125" />
                  <span className="text-charcoal/80 leading-relaxed" data-id="element-126">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti si */}
          <motion.div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border-t-4 border-charcoal/20" initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-127">
            <h3 className="text-2xl font-serif mb-6 text-charcoal/60" data-id="element-128">
              NO ES PARA TI SI...
            </h3>
            <ul className="space-y-4" data-id="element-129">
              {['Buscas soluciones quirúrgicas o pastillas mágicas.', 'Quieres pérdida de peso extrema sin importar tu salud.', 'No estás dispuesta a hacer cambios temporales en tu dieta.', 'Prefieres seguir ignorando las señales de tu cuerpo.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-130">
                  <XIcon className="w-6 h-6 text-charcoal/40 shrink-0 mt-0.5" data-id="element-131" />
                  <span className="text-charcoal/60 leading-relaxed" data-id="element-132">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}